import { Card, Group, Skeleton, Stack, Text } from "@mantine/core";
import { useApiQuery } from "@/hooks/useApiQuery";
import { useIsDark } from "@/hooks/useIsDark";
import { useTranslate } from "@/hooks/useTranslate";
import { apiClient } from "@/utils/api-client";

interface DivisionItem {
	name: string;
	count: number;
}

async function fetchDivisionList(): Promise<DivisionItem[]> {
	const { data } = await apiClient.GET("/api/noc/active-divisions", {
		params: { query: { idDesa: "desa1", limit: "5" } },
	});
	return (data?.data ?? []).map((d) => ({
		name: d.name,
		count: d.activityCount || 0,
	}));
}

export function DivisionList() {
	const t = useTranslate();
	const dark = useIsDark();

	const { data: divisions = [], isLoading: loading } = useApiQuery(
		["kinerja", "division-list"],
		fetchDivisionList,
	);

	return (
		<Card
			data-ai-target="divisi.teraktif"
			p="md"
			radius="xl"
			withBorder
			bg={dark ? "#1E293B" : "white"}
			style={{
				borderColor: dark ? "#334155" : "white",
				boxShadow: dark
					? "0 1px 3px 0 rgb(0 0 0 / 0.1)"
					: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
			}}
			h="100%"
		>
			<Text size="sm" fw={600} c={dark ? "white" : "#1E3A5F"} mb="md">
				{t.kinerjaDivisi.divisiTeraktif}
			</Text>
			<Stack gap="xs">
				{loading ? (
					<Stack gap="xs">
						{Array.from({ length: 5 }).map((_, i) => (
							// Skeleton placeholder statis (bukan data asli) — index sebagai key aman di sini.
							// biome-ignore lint/suspicious/noArrayIndexKey: static skeleton count, no reorder
							<Skeleton key={i} height={40} radius="md" />
						))}
					</Stack>
				) : divisions.length > 0 ? (
					divisions.map((division) => (
						<Group
							key={division.name}
							justify="space-between"
							align="center"
							style={{
								padding: "8px 12px",
								borderRadius: 8,
								backgroundColor: dark ? "#334155" : "#F1F5F9",
							}}
						>
							<Text size="sm" c={dark ? "white" : "#1E3A5F"}>
								{division.name}
							</Text>
							<Text size="sm" fw={600} c={dark ? "white" : "#1E3A5F"}>
								{division.count}
							</Text>
						</Group>
					))
				) : (
					<Text size="xs" c="dimmed" ta="center">
						{t.kinerjaDivisi.tidakAdaDataDivisi}
					</Text>
				)}
			</Stack>
		</Card>
	);
}
